import { FC, Fragment } from 'react';
import styled from 'styled-components';

import { Label } from '@/components/Forms';
import Text from '@/components/Text';
import { paymentMethodLabels, paymentMethods } from '@/utils/data/payments';
import { PaymentMethod } from '@/utils/enums';

const Box = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  border-radius: 4px;
  padding: 16px;
  padding-left: 12px;
`;

const Heading = styled(Text)`
  margin-bottom: 12px;
`;

const Radios = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
  gap: 12px 24px;
`;

const RadioCircle = styled.span`
  width: 16px;
  height: 16px;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto 0;
  position: absolute;
  border: 2px solid ${({ theme }) => theme.colors.gray};
  border-radius: 1px;
  transition: 0.2s ease-out all;
  border-radius: 50%;
  transition: border-color ease-out 0.2s;
  &:after {
    content: '';
    position: absolute;
    opacity: 0;
    width: 8px;
    height: 8px;
    background: ${({ theme }) => theme.colors.purple};
    border-radius: 50%;
    left: 2px;
    top: 2px;
    transition: opacity ease-out 0.2s;
  }
`;

const RadiosLabel = styled(Label)`
  position: relative;
  cursor: pointer;
  user-select: none;
  margin: 0;
  padding-left: 25px;
  white-space: nowrap;
`;

const RadioInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 1px;
  width: 1px;
  border-radius: 50%;
  &:checked ~ ${RadioCircle} {
    border-color: ${({ theme }) => theme.colors.purple};
    &::after {
      opacity: 1;
    }
  }
`;

interface Props {
  value: PaymentMethod;
  onChange: (method: PaymentMethod) => void;
  disabledMethods?: PaymentMethod[];
}

const PaymentTypeToggle: FC<Props> = ({
  value,
  onChange,
  disabledMethods = [],
}) => {
  return (
    <Box>
      <Heading $type="smallBold">Payment Type</Heading>
      <Text $type="smallNormal" $color="gray">
        Select how you want to receive this payment
      </Text>
      <Radios>
        {paymentMethods
          .filter((method) => !disabledMethods.includes(method))
          .map((method) => (
            <Fragment key={method}>
              <RadiosLabel>
                {paymentMethodLabels[method]}
                <RadioInput
                  type="radio"
                  name="payment_type"
                  checked={value === method}
                  onChange={() => onChange(method)}
                />
                <RadioCircle />
              </RadiosLabel>
            </Fragment>
          ))}
      </Radios>
    </Box>
  );
};

export default PaymentTypeToggle;
